import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const DataCommNetworkingModule = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Data Communications and Networking: A Communications Model – Data Communications, Evolution of Network, Requirements, Applications"
    videos={[
      "https://www.youtube.com/embed/PwFqQfyv0xM?list=PLrjkTql3jnm-iqlEOuVTkmCaRP8F2H3-u",
      "https://www.youtube.com/embed/Hizdc4XVJ1E?list=PLqleLpAMfxGCUpDRFUnLKeDrgBsPOwTQK",
      "https://www.youtube.com/embed/ZdOqrDd2Xj8?list=PLqleLpAMfxGCUpDRFUnLKeDrgBsPOwTQK",
      "https://www.youtube.com/embed/ng2rL1YBocg",
      "https://www.youtube.com/embed/YGmn2GZeR5Y"
    ]}
    takeaways={[
      { text: "These are basics; mostly direct question can come." }
    ]}
    questions={[
      "You are sending a mail from your VIT mail ID to a professor in Stanford. Identify the network devices (hardware) which are employed in the communication.",
      "Explain the components of a communications model with the help of a suitable diagram."
    ]}
    exampleVideos={[]}
  />
);
}

export default DataCommNetworkingModule;
